define('add_on_item_group_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('add_on_item_group_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>";
},"useData":true}, 'extensions/MHI/AddOnItemGroupCustomization/1.0.2/', 'extensions/MHI/AddOnItemGroupCustomization/1.0.2/', Handlebars);
});